<script setup lang="ts">
  import { computed } from 'vue'
  import { fmt } from '@/functions'

  const props = defineProps<{
    phone: string | null,
  }>()

  const chunkedPhone = computed(() => {
    if (!props.phone) return ['-']
    return fmt.phone(props.phone).split(' ')
  })
</script>

<template>
  <div class="space-x-1">
    <span
      v-for="(chunk, i) in chunkedPhone"
      :key="i"
      class="inline-block">
      {{ chunk }}
    </span>
  </div>
</template>
